import React from 'react';

const GoogleMap = () => {
  return (
    <section className="google-map-section">
      <div className="container">
        <h2 className="section-title">Find Us</h2>
        <div className="map-container">
          <iframe
            title="Uttam Diabetes Clinic Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3598.567890123456!2d85.123456!3d25.594054!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sUttam%20Diabetes%20Clinic%20%26%20Research%20Center!5e0!3m2!1sen!2sin!4v1234567890"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default GoogleMap;